export default "/images/vendor/@coreui/icons/svg/flag/cif-ge.svg?dd60df50127456a775baff7268e627bd";